<template>
  <nav class="pageNav">
    <ul class="pagiNation">
      
      <li :class="{'disabled': current == 1}"><a href="javascript:;" @click="setCurrent(1)"> 首页 </a></li>
      <li :class="{'disabled': current == 1}"><a href="javascript:;" @click="setCurrent(current - 1)">上一页</a></li>
      <li v-for="p in grouplist" :class="{'active': current == p.val,page}"><a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a>
      </li>
      <li :class="{'disabled': current == page}"><a href="javascript:;" @click="setCurrent(current + 1)">下一页</a></li>
      <li :class="{'disabled': current == page}"><a href="javascript:;" @click="setCurrent(page)"> 尾页 </a></li>
      <div class="clear"></div>
    </ul>
  </nav>
</template>

<script >
  export default{
    name: 'pagination',
    data(){
      return {
        current: this.currentPage
      }
    },
    props: {
      total: {// 数据总条数
        type: Number,
        default: 0
      },
      display: {// 每页显示条数
        type: Number,
        default: 10
      },
      currentPage: {// 当前页码
        type: Number,
        default: 1
      },
      pagegroup: {// 分页条数
        type: Number,
        default: 4,//这个关乎页面数的显示，改了别的78行也要改掉，不然点击过程中会少一个li
        /*coerce: function (v) {
          v = v > 0 ? v : 4;
          return v % 2 === 1 ? v: v+2 ;
        }*/
      }
    },
    computed: {
      page: function () { // 总页数
        return Math.ceil(this.total / this.display);
      },
      grouplist: function () { // 获取分页页码

        var len = this.page,//总共几页,总数据条数/每页几条
        	 temp = [], 
        	 list = [], 
        	 count = Math.floor(this.pagegroup / 2), //显示几个分页,向下取数，？？
        	 center = this.current;//点击时的页数，带有current类的数字
        	//console.log(count,center) 2,1  2,2  2,3  2,4  2,5  2,6
        if (len <= this.pagegroup) {//如果总共几页 小于 显示几个分页  2 《 3
          while (len--) {
            temp.push({text: this.page - len, val: this.page - len});
          };
          return temp;
        }

        while (len--) {
          temp.push(this.page - len);
        };
        //console.log(temp)//所有的页数 【1 2 3 4 5 6 】
        var idx = temp.indexOf(center);//当前点击的页数所在的位置 console.log(idx,count,center) 0,2,1  1,2,2   2,2,3  3,2,4  4,2,5  5,2,6
        
        //当只有页数1 2 会触发
        //console.log((idx < count) && ( center = center + count - idx))
        
        //console.log(this.current,count) 1,2  2,2  3,2  4,2  5,2  6,2  
        //只有5 6 会触发
        //console.log((this.current > this.page - count) && ( center = this.page - count+1))
        (idx < count) && ( center = center + count - idx);
        (this.current > this.page - count) && ( center = this.page - count+1);
        //console.log(center,count,center - count - 1) 3,2,0  3,2,0  3,2,0  4,2,1  5,2,2  5,2,2
        temp = temp.splice(center - count - 1, this.pagegroup);
        //console.log(temp)//显示的页数 【1 2 3 4】 【1 2 3 4】 【1 2 3 4】 【2 3 4 5】 【3 4 5 6】 【3 4 5 6】
        do {
          var t = temp.shift();
          list.push({
            text: t,
            val: t
          });
        } while (temp.length);
        //console.log(list)   0:{text: "...", val: 2}
		/*1:{text: 3, val: 3}
		2:{text: 4, val: 4}
		3:{text: 5, val: 5}
		4:{text: 6, val: 6}*/

        if (this.page > this.pagegroup) {//6>4  总共的页数大于显示的页数 总共六页，显示四页
        	//1 >3 

          (this.current > count + 1) && list.unshift({text: '...', val: list[0].val - 1});
          (this.current < this.page - count) && list.push({text: '...', val: list[list.length - 1].val + 1});
        }
        //console.log(list)显示在页面中的li
        return list;
      }
    },
    methods: {
      setCurrent: function (idx) {
        if (this.current != idx && idx > 0 && idx < this.page + 1) {
          this.current = idx;
          this.$emit('pagechange', this.current);
        }
      }
    }
  }
</script>

<style >
.pageNav{
	height: 24px;
  margin-top: 15px;
}
  .pagiNation {
    overflow: hidden;
    display: table;
    margin: 0 auto;
    /*width: 100%;*/
    
    height: 100%;
}
 .pagiNation li {
    float: left;
    height: 24px;
    border:1px solid #84898c;
    border-radius: 10px;
    margin: 0 10px;
    padding-left:18px;
    padding-right: 18px;
    color: #666;
}
 .pagiNation .page{
  height: 24px;
  line-height: 24px;
  text-align: center;
  width: 28px;
  padding:0;
  border-radius:50%;
 }
 .pagiNation li:hover {
   color: #07acff;
   border-color:#07acff;
 }
 .pagiNation  .active{
  color: #07acff;
   border-color:#07acff;
 }

</style>


// WEBPACK FOOTER //
// src/components/common/pagination.vue